import { render, staticRenderFns } from "./manageOrderNotices.vue?vue&type=template&id=f9a57ea4&scoped=true"
import script from "./manageOrderNotices.vue?vue&type=script&lang=js"
export * from "./manageOrderNotices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a57ea4",
  null
  
)

export default component.exports